export default __webpack_public_path__ + "static/media/email.ad7e4a3b.svg";